module.exports = __webpack_public_path__ + "img/02.8b446b84.png";